import React from 'react';
import { motion } from 'framer-motion';

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen bg-secondary flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-2xl w-full text-center bg-white rounded-2xl shadow-sm p-10 md:p-16"
      >
        <div className="mb-8">
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-accent tracking-widest">
            AURA ROSA
          </h1>
        </div>

        <h2 className="font-heading text-4xl md:text-5xl font-bold text-text-primary mb-6">
          Em breve
        </h2>

        <p className="text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl mx-auto">
          Estamos preparando uma experiência especial para você.
          Nossa loja estará disponível em breve.
        </p>
      </motion.div>
    </div>
  );
};

export default ComingSoonPage;